<template>
  <div class="detail">
    <div class="address">
      <div class="address__info">
        <div class="address__info--jibun">{{ address.jibunAddress }}</div>
        <div class="address__info--road">
          <span class="road-label">도로명</span>{{ address.roadAddress }}
        </div>
      </div>
      <div class="address-input">
        <input
          placeholder="상세주소"
          v-model="detail"
          v-focus
          @input="detail = $event.target.value"
        />
      </div>
    </div>
    <button class="detail__complete" @click="submit()">완료</button>
  </div>
</template>
<script>
export default {
  props: ["address"],
  methods: {
    submit() {
      this.address.detailAddress = this.detail;
      this.$emit("submit");
      this.$emit("close");
    },
  },
  mounted() {
    this.detail = this.address.detailAddress;
  },
  data() {
    return {
      detail: null,
    };
  },
};
</script>
<style scoped>
.address {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.road-label {
  background-color: var(--white);
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
  color: var(--gray-500);
  padding: 2px 6px;
  border: 1px solid var(--gray-300);
  border-radius: 4px;
  margin-right: 6px;
}
.detail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.detail__complete {
  width: 100%;
  border-radius: 10px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  margin-top: 32px;
}

.address__info--jibun {
  color: var(--gray-700);
  font-weight: 400;
}

.address__info--road {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: var(--gray-500);
}

@media all and (min-width: 1024px) {
  .address__info--jibun {
    font-size: 20px;
    line-height: 28px;
  }

  .detail__complete {
    margin-bottom: 56px;
  }

  .detail {
    justify-content: space-between;
  }
}
@media all and (max-width: 1023px) {
  .address__info--jibun {
    font-size: 18px;
    line-height: 26px;
  }

  .detail__complete {
    margin-bottom: 20px;
  }

  .detail {
  }
}
</style>
<style src="@/assets/css/newGlobal.css" scoped></style>
